import styled from '@emotion/styled'

export const Wrapper = styled.div`
  margin-left: 8%;
  margin-top: 7%;
`
